import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TableOfContents = ({ 
  slides, 
  currentSlide, 
  isOpen, 
  onToggle, 
  onSlideSelect 
}) => {
  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <div className={`fixed left-0 top-16 h-[calc(100vh-64px)] bg-surface border-r border-border transition-transform duration-300 ease-out z-20 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`} style={{ width: '320px' }}>
          <div className="flex flex-col h-full">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-border">
              <h3 className="font-heading font-semibold text-text-primary">
                Table of Contents
              </h3>
              <Button
                variant="ghost"
                iconName="X"
                iconSize={18}
                onClick={onToggle}
              />
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4">
              <div className="space-y-2">
                {slides.map((slide, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      onSlideSelect(index + 1);
                      onToggle();
                    }}
                    className={`w-full text-left p-3 rounded-lg nav-transition ${
                      currentSlide === index + 1
                        ? 'bg-primary text-primary-foreground'
                        : 'hover:bg-border-light text-text-secondary hover:text-text-primary'
                    }`}
                  >
                    <div className="flex items-start space-x-3">
                      <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                        currentSlide === index + 1
                          ? 'bg-primary-foreground text-primary'
                          : 'bg-border text-text-secondary'
                      }`}>
                        {index + 1}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-medium truncate">{slide.title}</div>
                        <div className={`text-xs mt-1 capitalize ${
                          currentSlide === index + 1 ? 'text-primary-foreground/80' : 'text-text-secondary'
                        }`}>
                          {slide.type}
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Toggle Button */}
        <button
          onClick={onToggle}
          className={`fixed left-4 top-20 w-10 h-10 bg-primary text-primary-foreground rounded-r-lg shadow-elevation-2 flex items-center justify-center nav-transition z-20 ${
            isOpen ? 'translate-x-80' : 'translate-x-0'
          }`}
          aria-label="Toggle table of contents"
        >
          <Icon name={isOpen ? 'ChevronLeft' : 'Menu'} size={16} />
        </button>
      </div>

      {/* Mobile Bottom Sheet */}
      <div className="lg:hidden">
        {/* Toggle Button */}
        <button
          onClick={onToggle}
          className="fixed bottom-4 left-4 w-12 h-12 bg-primary text-primary-foreground rounded-full shadow-elevation-2 flex items-center justify-center nav-transition z-20"
          aria-label="Toggle table of contents"
        >
          <Icon name="Menu" size={20} />
        </button>

        {/* Bottom Sheet */}
        {isOpen && (
          <div className="fixed inset-0 bg-black/50 z-30" onClick={onToggle}>
            <div 
              className="fixed bottom-0 left-0 right-0 bg-surface rounded-t-lg max-h-[70vh] content-reveal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex flex-col h-full">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-border">
                  <h3 className="font-heading font-semibold text-text-primary">
                    Table of Contents
                  </h3>
                  <Button
                    variant="ghost"
                    iconName="X"
                    iconSize={20}
                    onClick={onToggle}
                  />
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-4">
                  <div className="space-y-3">
                    {slides.map((slide, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          onSlideSelect(index + 1);
                          onToggle();
                        }}
                        className={`w-full text-left p-4 rounded-lg nav-transition ${
                          currentSlide === index + 1
                            ? 'bg-primary text-primary-foreground'
                            : 'hover:bg-border-light text-text-secondary hover:text-text-primary'
                        }`}
                      >
                        <div className="flex items-start space-x-3">
                          <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                            currentSlide === index + 1
                              ? 'bg-primary-foreground text-primary'
                              : 'bg-border text-text-secondary'
                          }`}>
                            {index + 1}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="font-medium">{slide.title}</div>
                            <div className={`text-sm mt-1 capitalize ${
                              currentSlide === index + 1 ? 'text-primary-foreground/80' : 'text-text-secondary'
                            }`}>
                              {slide.type}
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TableOfContents;